import type { ApiClient } from "../../api";
import {
  getApiV1AuditEvents,
  getApiV1AuditEventsByEvent,
  getApiV1AuditExports,
  getApiV1AuditExportsByExport,
  getApiV1AuditExportsByExportDownload,
  postApiV1AuditExports,
} from "../../api/generated";
import type { AuditFilters } from "./types";

export class AuditApi {
  constructor(private readonly client: ApiClient) {}

  list(filters: AuditFilters & { cursor?: string; per_page?: number } = {}) {
    return getApiV1AuditEvents(this.client, { query: filters });
  }

  async event(id: string) {
    return (
      await getApiV1AuditEventsByEvent(this.client, {
        path: { event: id },
      })
    ).data;
  }

  /** Ранее заказанные выгрузки: их нужно находить и после обновления страницы. */
  async exports() {
    return (await getApiV1AuditExports(this.client)).data;
  }

  async requestExport(filters: AuditFilters = {}) {
    return (
      await postApiV1AuditExports(this.client, {
        body: { format: "csv", filters },
      })
    ).data;
  }

  async exportStatus(id: string) {
    return (
      await getApiV1AuditExportsByExport(this.client, {
        path: { export: id },
      })
    ).data;
  }

  download(id: string, signal?: AbortSignal): Promise<ArrayBuffer> {
    return getApiV1AuditExportsByExportDownload(this.client, {
      path: { export: id },
      signal,
    });
  }
}
